import { render, staticRenderFns } from "./ReportStocks.vue?vue&type=template&id=58c2d29c"
import script from "./ReportStocks.vue?vue&type=script&lang=js"
export * from "./ReportStocks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports